import { cssColorValue, Image, Text } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';
import { Link } from '../../../../../LinkV2';
import { fadeInAnimation } from '../../../../fadeInAnimation';
const LinkWrapper = styled(Link).withConfig({
    shouldForwardProp: prop => !['delay'].includes(prop),
}) `
  ${({ delay }) => delay && fadeInAnimation(delay)}
`;
const WithMediaWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${cssColorValue('textBase')};
  .text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: start;
    gap: 6px;
  }
`;
const ImageWrapper = styled(Image) `
  aspect-ratio: 21 / 9;
  width: 100%;
  object-fit: cover;
`;
export const MobileGalleryLink = ({ image, description, link, trackingCategory, delay, }) => {
    var _a;
    const formattedLink = Object.assign(Object.assign({}, link), { trackingCategory });
    return (React.createElement(LinkWrapper, Object.assign({}, formattedLink, { delay: delay }),
        React.createElement(WithMediaWrapper, null,
            React.createElement(ImageWrapper, { src: (_a = image === null || image === void 0 ? void 0 : image.file) === null || _a === void 0 ? void 0 : _a.url }),
            React.createElement("div", { className: "text" },
                React.createElement(Text, { variant: "titleSmall" },
                    link.label,
                    " "),
                React.createElement(Text, { variant: "bodyMedium" }, description)))));
};
//# sourceMappingURL=index.js.map